export default __webpack_public_path__ + "static/favicon-c82c0ad30767ac10cc08c0477e4c29f8.ico";